/* eslint-disable import/no-cycle */
/* eslint no-lonely-if: 0 */

import {
  LOAD_REPRESENTATIVE,
  LOAD_REPRESENTATIVES,
  SEARCH_REPRESENTATIVES,
  LOAD_STORES,
  SEARCH_STORES,
  LOAD_SELECTED_STORES,
  LOAD_STORE_SUCCESS,
  LOAD_SELECTED_STORE_SUCCESS,
  CLEAR_SELECTED_STORE,
  NOTIFY_SUCCESS,
  NOTIFY_DANGER,
  CLEAR_SELECTED_STORES,
  HAS_INVOICE_NUMBER,
  LOADING_REPRESENTATIVE_DETAILS,
  LOADING_INVOICE_DATA,
  LOAD_INVOICE_DATA_SUCCESS,
  LOADING_LOGOTYPE,
  LOAD_LOGOTYPE_SUCCESS,
  LOADING_CHECKOUT_SETTINGS,
  LOADING_INVOICE_NUMBER,
  LOAD_PAYMENT_METHODS_BY_CHANNEL_SUCCESS,
  LOAD_INVOICE_NUMBER,
  LOAD_CHECKOUT_STYLING_SUCCESS,
  LOAD_TERMS_LINKS_SUCCESS,
  SET_INVOICE_DATA_SUCCESS,
  SET_LOGOTYPE_SUCCESS,
  EMPTY_TERMS_LINKS,
  EMPTY_INVOICE_DATA,
  EMPTY_LOGOTYPE,
  LOAD_CURRENT_STORE_DEBIT_DISABLED,
} from './action-types'
import { isUserResursAdmin, request } from './auth-actions'
import { notify } from './notification-actions'
import { genericError, silentError } from './action-utils'
import representativeServiceApi from '../../api/representative-service-api'
import userServiceApi from '../../api/user-service-api'
import { getText } from '../../internal/TextLabels/text'
import {
  isFranchiseeOrNoRelations,
  getRepresentativeId,
  getStoreId,
  getCurrentStore,
  getCurrentRepresentative,
} from '../../util/helpers'

export const getCurrentUserStoresSuccess = response => ({
  type: LOAD_STORES,
  response,
})

export const searchCurrentUserStoresSuccess = response => ({
  type: SEARCH_STORES,
  response,
})

export const getSelectedStoresSuccess = response => ({
  type: LOAD_SELECTED_STORES,
  response,
})

export const getCurrentUserRepresentativesSuccess = response => ({
  type: LOAD_REPRESENTATIVES,
  response,
})

export const searchCurrentUserRepresentativesSuccess = response => ({
  type: SEARCH_REPRESENTATIVES,
  response,
})

export const getRepresentativeSuccess = response => ({
  type: LOAD_REPRESENTATIVE,
  response,
})

export const loadStoreSuccess = currentStore => ({
  type: LOAD_STORE_SUCCESS,
  currentStore,
})

export const loadSelectedStoreSuccess = selectedStore => ({
  type: LOAD_SELECTED_STORE_SUCCESS,
  selectedStore,
})

export const clearSelectedStore = () => ({ type: CLEAR_SELECTED_STORE })

export const clearSelectedStores = () => ({ type: CLEAR_SELECTED_STORES })

export const setHasInvoiceNumber = success => ({
  type: HAS_INVOICE_NUMBER,
  success,
})

const loadingRepresentativeDetails = loading => ({
  type: LOADING_REPRESENTATIVE_DETAILS,
  loading,
})

const loadingInvoiceData = loading => ({
  type: LOADING_INVOICE_DATA,
  loading,
})

const loadInvoiceDataSuccess = response => ({
  type: LOAD_INVOICE_DATA_SUCCESS,
  response,
})

const invoiceDataNotFound = () => ({
  type: EMPTY_INVOICE_DATA,
})

const setInvoiceDataSuccess = response => ({
  type: SET_INVOICE_DATA_SUCCESS,
  response,
})

const loadingLogotype = loading => ({
  type: LOADING_LOGOTYPE,
  loading,
})

export const loadLogotypeSuccess = response => ({
  type: LOAD_LOGOTYPE_SUCCESS,
  response,
})

export const setLogotypeSuccess = response => ({
  type: SET_LOGOTYPE_SUCCESS,
  response,
})

const logotypeNotFound = () => ({
  type: EMPTY_LOGOTYPE,
})

const loadingCheckoutSettings = loading => ({
  type: LOADING_CHECKOUT_SETTINGS,
  loading,
})

const loadCheckoutStyleSuccess = response => ({
  type: LOAD_CHECKOUT_STYLING_SUCCESS,
  response,
})

const loadTermsLinksSuccess = response => ({
  type: LOAD_TERMS_LINKS_SUCCESS,
  response,
})

const termsLinksNotFound = () => ({
  type: EMPTY_TERMS_LINKS,
})

const loadingInvoiceNumber = loading => ({
  type: LOADING_INVOICE_NUMBER,
  loading,
})

const getInvoiceNumberSuccess = response => ({
  type: LOAD_INVOICE_NUMBER,
  response,
})

const getPaymentMethodsByChannelSuccess = response => ({
  type: LOAD_PAYMENT_METHODS_BY_CHANNEL_SUCCESS,
  response,
})

const loadCurrentStoreDebitDisabled = response => ({
  type: LOAD_CURRENT_STORE_DEBIT_DISABLED,
  response,
})

export const getCurrentUserStores = representativeId => (dispatch, getState) =>
  dispatch(
    isUserResursAdmin(getState())
      ? request(
          representativeServiceApi.getRepresentativeStores,
          representativeId ?? getState().storeInfo.currentRepresentative.id,
        )
      : request(userServiceApi.getMeStores, {
          representativeId,
        }),
  )
    .then(data => {
      dispatch(getCurrentUserStoresSuccess(data))
    })
    .catch(error => {
      genericError(error)
      throw error
    })

export const searchCurrentUserStores =
  (representativeId, pageInfo, searchInfo) => (dispatch, getState) =>
    dispatch(
      request(
        isUserResursAdmin(getState())
          ? representativeServiceApi.searchRepresentativeStores({
              representativeId,
              pageInfo,
              searchInfo,
            })
          : userServiceApi.searchMeStores({
              representativeId,
              pageInfo,
              searchInfo,
            }),
      ),
    )
      .then(data => dispatch(searchCurrentUserStoresSuccess(data)))
      .catch(error => {
        genericError(error)
        throw error
      })

export const getCurrentUserRepresentatives = () => (dispatch, getState) => {
  if (isUserResursAdmin(getState())) {
    return dispatch(request(representativeServiceApi.getRepresentatives, null))
      .then(data => {
        dispatch(getCurrentUserRepresentativesSuccess(data))
      })
      .catch(error => {
        genericError(error)
        throw error
      })
  }

  return dispatch(request(userServiceApi.getMeRepresentatives))
    .then(data => {
      dispatch(getCurrentUserRepresentativesSuccess(data))
    })
    .catch(error => {
      genericError(error)
      throw error
    })
}

export const searchCurrentUserRepresentatives =
  (pageInfo, searchInfo) => (dispatch, getState) =>
    dispatch(
      request(
        isUserResursAdmin(getState())
          ? representativeServiceApi.searchRepresentatives({
              pageInfo,
              searchInfo,
            })
          : userServiceApi.searchMeRepresentatives({ pageInfo, searchInfo }),
      ),
    )
      .then(data => dispatch(searchCurrentUserRepresentativesSuccess(data)))
      .catch(error => {
        genericError(error)
        throw error
      })

export const getSelectedStores = userId => dispatch => {
  return dispatch(
    request(userServiceApi.getUserStores, {
      userId,
      representativeId: null,
    }),
  )
    .then(data => {
      dispatch(getSelectedStoresSuccess(data))
    })
    .catch(error => {
      genericError(error)
      throw error
    })
}

export const getLimitedRepresentativeStores = repId => dispatch => {
  return dispatch(
    request(representativeServiceApi.getLimitedRepresentativeStores(repId)),
  )
    .then(data => data.stores)
    .catch(error => {
      genericError(error)
      throw error
    })
}

export const getLimitedStores = storeIds => dispatch => {
  return dispatch(request(representativeServiceApi.getLimitedStores(storeIds)))
    .then(data => data.stores)
    .catch(error => {
      genericError(error)
      throw error
    })
}

export const getRepresentative = id => dispatch => {
  return dispatch(request(representativeServiceApi.getRepresentative, id))
    .then(data => {
      dispatch(getRepresentativeSuccess(data))
    })
    .catch(error => {
      genericError(error)
      throw error
    })
}

export const getRepresentativeDetails = () => (dispatch, getState) => {
  dispatch(loadingRepresentativeDetails(true))
  return dispatch(
    request(
      representativeServiceApi.getRepresentative,
      getState().auth.representative.representativeUID,
    ),
  )
    .then(data => {
      dispatch(getRepresentativeSuccess(data))
      dispatch(loadingRepresentativeDetails(false))
    })
    .catch(error => {
      dispatch(loadingRepresentativeDetails(false))
      genericError(error)
      throw error
    })
}

export const getInvoiceNumber = () => (dispatch, getState) => {
  dispatch(loadingInvoiceNumber(true))
  return dispatch(
    request(
      representativeServiceApi.getNextInvoiceNumber,
      getStoreId(getState()),
    ),
  )
    .then(data => {
      dispatch(getInvoiceNumberSuccess(data.result || 0))
      dispatch(setHasInvoiceNumber(true))
      dispatch(loadingInvoiceNumber(false))
    })
    .catch(error => {
      dispatch(loadingInvoiceNumber(false))
      genericError(error)
      throw error
    })
}

export const setInvoiceNumber = nextNumber => (dispatch, getState) => {
  return dispatch(
    isFranchiseeOrNoRelations(getState())
      ? request(representativeServiceApi.putStoreInvoiceNumber, {
          storeId: getStoreId(getState()),
          nextNumber,
        })
      : request(representativeServiceApi.putRepresentativeInvoiceNumber, {
          representativeId: getRepresentativeId(getState()),
          nextNumber,
        }),
  )
    .then(() => {
      dispatch(getInvoiceNumber())
      notify(NOTIFY_SUCCESS, getText('invoiceNumberSettings.successOnSave'))
    })
    .catch(error => {
      silentError(error)
      genericError(getText('invoiceNumberSettings.errorOnSave'))

      throw error
    })
}

export const checkHasInvoiceNumber = () => (dispatch, getState) => {
  return dispatch(getInvoiceNumber())
    .then(() =>
      dispatch(setHasInvoiceNumber(!!getState().settings.invoiceNumber)),
    )
    .catch(error => {
      genericError(error)

      throw error
    })
}

export const getStore = storeId => dispatch => {
  return dispatch(request(representativeServiceApi.getStore, storeId))
    .then(data => {
      dispatch(loadStoreSuccess(data))
    })
    .catch(error => {
      genericError(error)
      throw error
    })
}

export const getSelectedStore = storeId => dispatch => {
  return dispatch(request(representativeServiceApi.getStore, storeId))
    .then(data => {
      dispatch(loadSelectedStoreSuccess(data))
    })
    .catch(error => {
      genericError(error)
      throw error
    })
}

export const resetSelectedStores = () => dispatch => {
  return dispatch(clearSelectedStores())
}

export const checkDebitDisabled = () => (dispatch, getState) =>
  dispatch(
    request(
      representativeServiceApi.getStoreDebitEnabled(getStoreId(getState())),
    ),
  )
    .then(data => dispatch(loadCurrentStoreDebitDisabled(data)))
    .catch(error => {
      genericError(error)
      throw error
    })

// CART ITEM MERGE PARAMS

export const getCartItemMergeParams = () => (dispatch, getState) =>
  dispatch(
    isFranchiseeOrNoRelations(getState())
      ? request(
          representativeServiceApi.getStoreCartItemMergeParams,
          getStoreId(getState()),
        )
      : request(
          representativeServiceApi.getRepresentativeCartItemMergeParams,
          getRepresentativeId(getState()),
        ),
  )
    .then(({ params }) => params)
    .catch(error => {
      genericError(error)
      throw error
    })

export const updateCartItemMergeParams = params => (dispatch, getState) =>
  dispatch(
    isFranchiseeOrNoRelations(getState())
      ? request(representativeServiceApi.putStoreCartItemMergeParams, {
          id: getStoreId(getState()),
          requestBody: { params },
        })
      : request(representativeServiceApi.putRepresentativeCartItemMergeParams, {
          id: getRepresentativeId(getState()),
          requestBody: { params },
        }),
  )
    .then(data => data.params)
    .catch(error => {
      genericError(error)
      throw error
    })

// PAYMENT METHODS

export const getPaymentMethodsByChannel = channel => (dispatch, getState) => {
  return dispatch(
    isFranchiseeOrNoRelations(getState())
      ? request(
          representativeServiceApi.getStorePaymentMethods(
            getStoreId(getState()),
            channel,
          ),
        )
      : request(
          representativeServiceApi.getRepresentativePaymentMethods(
            getRepresentativeId(getState()),
            channel,
          ),
        ),
  )
    .then(data =>
      dispatch(getPaymentMethodsByChannelSuccess(data.paymentMethods)),
    )
    .catch(error => {
      genericError(error)
      throw error
    })
}

export const updateOrderDateAndFee = (channel, requestData) => {
  return dispatch => {
    return dispatch(
      request(
        representativeServiceApi.updateOrderDateAndFee(channel, requestData),
      ),
    )
      .then(() => {
        dispatch(getPaymentMethodsByChannel(channel))
        notify(NOTIFY_SUCCESS, getText('paymentSettings.paymentMethods.saved'))
      })
      .catch(error => {
        notify(NOTIFY_DANGER, getText('paymentSettings.paymentMethods.error'))
        silentError(error)

        throw error
      })
  }
}

// INVOICE DATA

export const getInvoiceData = () => (dispatch, getState) => {
  dispatch(loadingInvoiceData(true))
  return dispatch(
    request(
      representativeServiceApi.getStoreInvoiceData,
      getStoreId(getState()),
    ),
  )
    .then(data => {
      dispatch(loadInvoiceDataSuccess(data))
      dispatch(loadingInvoiceData(false))
    })
    .catch(error => {
      if (error.status === 404) {
        dispatch(invoiceDataNotFound())
        dispatch(loadingInvoiceData(false))
      } else {
        genericError(error)
        dispatch(loadingInvoiceData(false))
        throw error
      }
    })
}

// STORE SETTINGS

const getStoreSettingsValidationErrorMessage = error => {
  let errorMessage = getText('storeSettings.storeinfo.error')
  if (
    error.data &&
    error.data.validationErrors &&
    error.data.validationErrors.length
  ) {
    const mappings = {
      'address.name': 'legalname',
      'address.street': 'street',
      'address.zipCode': 'zip',
      'address.city': 'city',
      'address.country': 'country',
      webpage: 'web',
      companyTaxNote: 'taxNote',
      tradeName: 'digitalname',
    }
    errorMessage += ` [${error.data.validationErrors
      .map(
        ({ fieldName, message }) =>
          `${getText(
            `storeSettings.storeinfo.${mappings[fieldName] || fieldName}`,
          )}: ${message}`,
      )
      .join(',')}]`
  }
  return errorMessage
}

const setInvoiceData = newValues => (dispatch, getState) =>
  dispatch(
    request(representativeServiceApi.putStoreInvoiceData, {
      storeId: getStoreId(getState()),
      newValues,
    }),
  ).then(data => dispatch(setInvoiceDataSuccess(data)))

const setCurrentRepresentative = requestData => (dispatch, getState) =>
  dispatch(
    request(
      representativeServiceApi.putRepresentative(
        getRepresentativeId(getState()),
        requestData,
      ),
    ),
  ).then(data => dispatch(getRepresentativeSuccess(data)))

const setCurrentStore = requestData => (dispatch, getState) =>
  dispatch(
    request(
      representativeServiceApi.putStore(getStoreId(getState()), requestData),
    ),
  ).then(data => dispatch(loadStoreSuccess(data)))

export const updateStoreSettings =
  (invoiceData, tradeName) => (dispatch, getState) =>
    dispatch(setInvoiceData(invoiceData))
      .then(() => {
        if (tradeName) {
          const isStore = isFranchiseeOrNoRelations(getState())
          const newRepresentativeOrStoreData = {
            ...(isStore
              ? getCurrentStore(getState())
              : getCurrentRepresentative(getState())),
            tradeName,
          }
          return dispatch(
            isStore
              ? setCurrentStore(newRepresentativeOrStoreData)
              : setCurrentRepresentative(newRepresentativeOrStoreData),
          )
        }
        return Promise.resolve()
      })
      .then(() => {
        notify(NOTIFY_SUCCESS, getText('storeSettings.storeinfo.saved'))
      })
      .catch(error => {
        silentError(error)
        notify(NOTIFY_DANGER, getStoreSettingsValidationErrorMessage(error))
      })

// LOGOTYPE

export const getLogotype = () => (dispatch, getState) => {
  dispatch(loadingLogotype(true))
  return dispatch(
    request(representativeServiceApi.getStoreLogotype, getStoreId(getState())),
  )
    .then(data => {
      dispatch(loadLogotypeSuccess(data))
      dispatch(loadingLogotype(false))
    })
    .catch(error => {
      dispatch(logotypeNotFound())
      dispatch(loadingLogotype(false))
      if (error.status !== 404) {
        genericError(error)
        throw error
      }
    })
}

export const updateLogotype = (logotype, fileName) => (dispatch, getState) => {
  return dispatch(
    request(representativeServiceApi.postStoreLogotype, {
      storeId: getStoreId(getState()),
      logotype,
      fileName,
    }),
  )
    .then(data => {
      dispatch(setLogotypeSuccess(data))
      notify(NOTIFY_SUCCESS, getText('logotypeSettings.saved'))
    })
    .catch(error => {
      notify(NOTIFY_DANGER, getText('logotypeSettings.error'))
      silentError(error)
      throw error
    })
}

// CHECKOUT SETTINGS

export const getCheckoutSettings = () => (dispatch, getState) => {
  dispatch(loadingCheckoutSettings(true))
  const isFranchiseeOrNoRelationsConstant = isFranchiseeOrNoRelations(
    getState(),
  )
  return dispatch(
    isFranchiseeOrNoRelationsConstant
      ? request(
          representativeServiceApi.getStoreCheckoutSettings,
          getStoreId(getState()),
        )
      : request(
          representativeServiceApi.getRepresentativeCheckoutSettings,
          getRepresentativeId(getState()),
        ),
  )
    .then(data => {
      dispatch(loadCheckoutStyleSuccess(data))
      dispatch(
        isFranchiseeOrNoRelationsConstant
          ? request(
              representativeServiceApi.getStoreTermsLinks,
              getStoreId(getState()),
            )
          : request(
              representativeServiceApi.getRepresentativeTermsLinks,
              getRepresentativeId(getState()),
            ),
      )
        .then(termsLinksResponse => {
          dispatch(loadTermsLinksSuccess(termsLinksResponse))
          dispatch(loadingCheckoutSettings(false))
        })
        .catch(error => {
          if (error.status === 404) {
            dispatch(termsLinksNotFound())
            dispatch(loadingCheckoutSettings(false))
          } else {
            genericError(error)
            dispatch(loadingCheckoutSettings(false))
            throw error
          }
        })
    })
    .catch(error => {
      genericError(error)
      dispatch(loadingCheckoutSettings(false))
      throw error
    })
}

export const updateCheckoutSettings =
  ({ checkoutStyling, language, termsLink }) =>
  (dispatch, getState) => {
    return dispatch(
      isFranchiseeOrNoRelations(getState())
        ? request(representativeServiceApi.postStoreCheckoutSettings, {
            storeId: getStoreId(getState()),
            checkoutStyling,
          })
        : request(representativeServiceApi.postRepresentativeCheckoutSettings, {
            representativeId: getRepresentativeId(getState()),
            checkoutStyling,
          }),
    )
      .then(data => {
        dispatch(loadCheckoutStyleSuccess(data))
        dispatch(
          isFranchiseeOrNoRelations(getState())
            ? request(representativeServiceApi.updateStoreTermsLink, {
                storeId: getStoreId(getState()),
                termsLink,
                language,
              })
            : request(representativeServiceApi.updateRepresentativeTermsLink, {
                representativeId: getRepresentativeId(getState()),
                termsLink,
                language,
              }),
        )
          .then(termsLinkResponse => {
            dispatch(loadTermsLinksSuccess(termsLinkResponse))
            notify(NOTIFY_SUCCESS, getText('storeSettings.checkout.saved'))
          })
          .catch(error => {
            silentError(error)
            notify(
              NOTIFY_DANGER,
              getText('storeSettings.checkout.termsLink.error'),
            )

            throw error
          })
      })
      .catch(error => {
        silentError(error)
        notify(NOTIFY_DANGER, getText('storeSettings.checkout.font.error'))

        throw error
      })
  }
